import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

class Finance extends React.PureComponent {

    render() {
        let link = 'https://finance.ifeng.com/loc/fengReport/list';

        console.log('aaa');

        return (
            <div className={styles.financeAd}>
                <a className={styles.financeAdText} href={link} target="_blank" rel="noopener noreferrer">
                    投资、理财、买保险遇陷阱投诉无门？来凤凰投诉！
                </a>
                <a className={styles.financeAdPic} href={link} target="_blank" rel="noopener noreferrer">
                    <img src="https://x0.ifengimg.com/ucms/2026_12/870A5F7C6EAA71A0D7805D661B9D39C31263487D_size540_w5080_h825.jpg" />
                </a>
            </div>
        );
    }
}

export default errorBoundary(Finance);
